<template>
	<div class="section-title-container">
    <slot></slot>
	</div>
</template>

<script>

export default {
  name: 'SectionTitle',
}
</script>

<style lang="scss" scoped>
.section-title-container {
	padding: 40px 0;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 95%;
	margin: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/LP/atoms/SectionTitle.vue